import { Injectable } from '@angular/core';
import { Query } from '@datorama/akita';
import {
    CheckoutWizardSettingsState,
    CheckoutWizardSettingsStore,
} from './checkout-wizard-settings.store';
import { map } from 'rxjs/operators';
import { DomSanitizer } from '@angular/platform-browser';
import { Observable } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class CheckoutWizardSettingsQuery extends Query<
    CheckoutWizardSettingsState
> {
    constructor(
        protected store: CheckoutWizardSettingsStore,
        private sanitizer: DomSanitizer
    ) {
        super(store);
    }

    /*-----------*/
    /** GETTERS */
    /*----------*/

    get productList() {
        return this.getValue()?.productList;
    }

    selectUrlCheckoutSafe(): Observable<any> {
        return this.select('urlCheckout').pipe(
            map((url) => {
                if (url && url !== '') {
                    return this.sanitizer.bypassSecurityTrustResourceUrl(url);
                } else {
                    return null;
                }
            })
        );
    }
}
